import { createContext, useContext } from "react";
import { customerStore } from "./customer/CustomerStore";
import { adminStore } from "./admin/AdminStore";
export const stores = {
  customerStore,
  adminStore,
};
const StoreContext = createContext(stores);
export const useStores = () => useContext(StoreContext);
